import SimBlinkIcon from "@/plugins/icons/sim/BlinkIcon";
import SimHappyIcon from "@/plugins/icons/sim/HappyIcon";
import SimThinkingIcon from "@/plugins/icons/sim/ThinkingIcon";

export default {
    simBlink: {component: SimBlinkIcon},
    simHappy: {component: SimHappyIcon},
    simThinking: {component: SimThinkingIcon},
};
